import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue';


const __default__ = { name: 'ProspectsByStatus' }


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

// Dark mode
const isDarkMode = ref(window.matchMedia('(prefers-color-scheme: dark)').matches);
window.matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', e => isDarkMode.value = e.matches);

// Series
const series = computed(() => [
  Number(props.data?.Client?.sum_total ?? 0),
  Number(props.data?.Lead?.sum_total ?? 0),
]);

// === Paleta por hostname ===
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

const dominiomediosPalette = ['#88102e', '#be103b']; // Clientes, Prospectos
const bluePalette          = ['#2563eb', '#60a5fa']; // base + claro

const computedColors = computed(() => (
  hostname === 'crm.dominiomedios.com' ? dominiomediosPalette : bluePalette
));

const options = computed(() => ({
  labels: ['Clientes', 'Prospectos'],
  chart: {
    type: 'pie',
    foreColor: isDarkMode.value ? '#fff' : '#333',
  },
  legend: {
    position: 'bottom',
    labels: { colors: isDarkMode.value ? '#fff' : '#333' },
    markers: { strokeWidth: 0 }
  },
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '21px',
      fontWeight: 900,
      colors: [isDarkMode.value ? '#fff' : 'white'],
    },
    formatter: (val: number) => `${val.toFixed(1)}%`
  },
  stroke: { width: 0 },
  colors: computedColors.value,   // ← paleta dinámica
  yaxis: {
    categories: [],
    labels: {
      formatter: (val: any) =>
        Number(val).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }),
      style: {
        fontSize: '21px',
        fontWeight: 900,
        color: isDarkMode.value ? '#fff' : '#333',
      },
    },
    tickPlacement: 'on'
  },
  responsive: [{
    breakpoint: 480,
    options: { legend: { position: 'bottom' } }
  }]
}));

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, { class: "ma-0 mb-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("Cotizaciones Clientes vs Prospectos")
          ])),
          _: 1,
          __: [0]
        }),
        _createVNode(_component_v_spacer)
      ]),
      _: 1
    }),
    _createVNode(_component_apexchart, {
      type: "pie",
      options: options.value,
      series: series.value,
      height: "300"
    }, null, 8, ["options", "series"])
  ]))
}
}

})